/* src/app/pages/auth/password/reset/component.scss */
.error {
  font-size: 12px;
}
/*# sourceMappingURL=component.css.map */
